import React from 'react';
// @ts-ignore
import styles from './PatientDataVerificationCSSZResult.module.scss';
import FormattedDate from '../../../../../Components/FormattedDate';
import Button from '../../../../../Components/Button/Button';
import { Theme } from '../../../../../Enums/Theme.enum';
import useTranslation from '../../../../../Hooks/useTranslation';

export interface PatientDataVerificationCSSZResultExtra {
	date: string;
	address: {
		street: string;
		descriptive_number: string;
		city: string;
		post_code: string;
		guide_number: string;
	};
}

interface Props {
	onClick: () => void;
	extra: PatientDataVerificationCSSZResultExtra;
}

const PatientDataVerificationCSSZResult: React.FC<Props> = ({
	onClick,
	extra,
}) => {
	const { t } = useTranslation();

	return (
		<div className={styles.wrapper}>
			<div>
				<div className={styles.title}>
					{t('component.patientDataVerificationCSSZResult.dateTitle')}{' '}
					<FormattedDate date={extra.date} />:
				</div>
			</div>
			<div>
				<div>
					{extra.address.street} {extra.address.descriptive_number} /{' '}
					{extra.address.guide_number}, {extra.address.city}{' '}
					{extra.address.post_code}
				</div>
			</div>
			<div>
				<div className={styles.title}>
					{t('component.patientDataVerificationCSSZResult.info')}
				</div>
			</div>
			<div>
				<Button
					theme={Theme.GREEN}
					title='base.shared.ok'
					onClick={onClick}
					className={styles.button}
				/>
			</div>
		</div>
	);
};

export default PatientDataVerificationCSSZResult;
